import React from "react";

const TableSkeleton = ({ tableImage = true }) => {
  return (
    <div className="bg-white divide-y divide-shades-04 rounded-b-lg -mt-px">
      {[...Array(10)].map((_, index) => (
        <div
          key={index}
          className="skeleton-loader w-full relative overflow-hidden py-2">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-shine"></div>
          <div className="flex items-center h-full px-2 space-x-4 animate-pulse !transform-none">
            {tableImage && <div className="w-8 h-8 bg-slate-200/50 rounded-full flex-shrink-0"></div>}

            <div className="flex flex-grow flex-shrink gap-4">
              <div className="h-6 bg-slate-200/50 rounded w-1/4"></div>
              <div className="h-6 bg-slate-200/50 rounded w-1/4"></div>
              <div className="h-6 bg-slate-200/50 rounded w-1/4"></div>
              <div className="h-6 bg-slate-200/50 rounded w-1/4"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
